import { CommonModule } from '@angular/common';
import { Component, model, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/auth.model';

interface DataSidebar {
  titulo: string;
  link: string;
  icono: string;
  activo: boolean;
  grupo: string;
}

@Component({
  selector: 'app-component-sidebar',
  imports: [RouterLink, CommonModule],
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  isCollapsed = model<boolean>(false);
  currentUser: User | null = null;
  loading = false;
  sessionRemainingSeconds: number | null = null;

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
    // Suscribirse al usuario actual
    this.authService.currentUser$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        this.currentUser = user;
        console.log('Usuario actual:', this.currentUser);
      });

    this.authService.sessionRemainingSeconds$
      .pipe(takeUntil(this.destroy$))
      .subscribe((seconds) => {
        this.sessionRemainingSeconds = seconds;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleSidebar() {
    this.isCollapsed.set(!this.isCollapsed());
  }

  dataSidebar: DataSidebar[] = [
    {
      titulo: 'Inicio',
      link: 'dashboard',
      icono: 'bi-house-door',
      activo: false,
      grupo: 'general',
    },
    {
      titulo: 'Empresas',
      link: 'dashboard/empresas',
      icono: 'bi-building',
      activo: false,
      grupo: 'module',
    },
    {
      titulo: 'Licencias',
      link: 'dashboard/licencias',
      icono: 'bi-file-earmark-text',
      activo: false,
      grupo: 'module',
    },
    {
      titulo: 'Usuarios',
      link: 'dashboard/admin/usuarios',
      icono: 'bi-person-badge',
      activo: false,
      grupo: 'admin',
    },
  ];

  generalItems = this.dataSidebar.filter((item) => item.grupo === 'general');
  moduleItems = this.dataSidebar.filter((item) => item.grupo === 'module');
  adminItems = this.dataSidebar.filter((item) => item.grupo === 'admin');

  cambiarActivo(url: string): void {
    const cleanUrl = url.replace(/^\/|\/$/g, '');
    this.dataSidebar.forEach((element) => {
      const cleanLink = element.link.replace(/^\/|\/$/g, '');
      element.activo = cleanUrl.endsWith(cleanLink);
    });
  }

  cerrarSidebar(): void {
    if (window.innerWidth < 992) {
      this.isCollapsed.set(true);
    }
  }

  get sessionRemainingLabel(): string {
    if (this.sessionRemainingSeconds === null) {
      return 'Sesion activa';
    }

    const minutes = Math.floor(this.sessionRemainingSeconds / 60);
    const seconds = this.sessionRemainingSeconds % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  }

  get isSessionExpiringSoon(): boolean {
    return (
      this.sessionRemainingSeconds !== null &&
      this.sessionRemainingSeconds <= 120
    );
  }

  logout(): void {
    this.loading = true;
    this.authService
      .logout()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.loading = false;
          // El servicio ya maneja la redirección
        },
        error: (error) => {
          console.error('Error durante logout:', error);
          this.loading = false;
          // Aunque falle, limpiamos y redirigimos
          this.router.navigate(['/auth/login']);
        },
      });
  }
}
